import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { icons } from '../mockData/icons-data';

const IconsApi = [
  rest.get(`${API_ROOT}icons`, (req, res, ctx) => {
    const mapped = req.url.searchParams.get('mapped');
    if (mapped === 'true') {
      return res(ctx.json(icons));
    }
    return res(ctx.json({ data: [] }));
  }),
];
export default IconsApi;
